/** @format */

import React from 'react'
import { NavLink } from 'react-router-dom'
import Images from '../Images';
import { Result, Button } from 'antd'

import './styles.css'

export default function PageError(props) {
	return (
		<Result
			icon={<Images  
				default=
				{props.detailError.statusCode === 500 
					? "https://storage.googleapis.com/tirx-resources-production/84527077-7348-4e5b-9ae5-c82c04fc93fa.png"
					: "https://storage.googleapis.com/tirx-resources-production/5ba15053-cc87-478e-84fa-bd74b905c067.png "
				}
				alt={`${props.detailError.statusCode} error`}
				classContent='error-img'
			/>}
			title={props.detailError.statusCode}
			subTitle={props.detailError.message}
			extra={
				<Button type='primary'>
					<NavLink to='/'>Back Home</NavLink>
				</Button>
			}
		/>
	)
}
